module.exports = __webpack_public_path__ + "fonts/Lato-Thin.0faa1074.woff2";